module.exports = __webpack_public_path__ + "static/media/kpi.35b7e53d.png";